export const GRID_EDITING_FILTER =
  'grayscale(1) contrast(0.25) brightness(1.75)';
